function sanitizeHTML(str) {
  return str.replace(/[^\w. ]/gi, function (c) {
    return '&#' + c.charCodeAt(0) + ';';
  });
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function replaceParamByName(params) {
  const keys = Object.keys(params);
  const json = queryStringToJSON(window.location.search);

  keys.forEach((key) => {
    if (params[key]) {
      json[key] = params[key];
    } else {
      delete json[key];
    }
  });

  const queryString = Object.keys(json).length !== 0
    ? '?' + Object.keys(json).map(key => key + '=' + encodeURIComponent(json[key])).join('&')
    : '';

  window.location = window.location.pathname + queryString;
}

function queryStringToJSON(queryString) {
  if(queryString.indexOf('?') > -1){
    queryString = queryString.split('?')[1];
  }

  const pairs = queryString.split('&');
  let result = {};

  pairs.forEach((pair) => {
    if (pair !== '') {
      pair = pair.split('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    }
  });

  return result;
}

function parseLocale(locale) {
  locale = locale
    ? locale.slice(0, 2).toUpperCase()
    : undefined;

  return locale;
}

/**
 * on questionnaire and business-input
 * check validity of the locale when it comes from query params
 * @param {string} locale
 */
function isValidLocale(locale) {
  const countries = ['EN', 'FR', 'IT', 'ES', 'NL', 'DE'];
  if (countries.indexOf(locale) === -1) {
    return false;
  } else {
    return true;
  }
}

/**
 * Random number
 */
function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) ) + min;
}

/**
 * Countdown counter, used on watch template but could be useful for several pages
 */
function countdown(time) {
  var timeLeft = Math.round((time - Date.now()) / 1000);
  var oneHour = 60 * 60;
  var oneDay = oneHour * 24;

  var days = Math.floor(timeLeft / oneDay);

  timeLeft -= days * oneDay;

  var hours = Math.floor(timeLeft / oneHour);

  timeLeft -= hours * oneHour;

  var minutes = Math.floor(timeLeft / 60);
  var seconds = timeLeft - minutes * 60;

  days = String(days);
  hours = String(hours);
  minutes = String(minutes);
  seconds = String(seconds);

  $('.days big').text((days.length == 2) ? days : '0' + days);
  $('.hours big').text((hours.length == 2) ? hours : '0' + hours);
  $('.minutes big').text((minutes.length == 2) ? minutes : '0' + minutes);
  $('.seconds big').text((seconds.length == 2) ? seconds : '0' + seconds);

  setTimeout(countdown, 1000, time);
}
